import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useEffect, useState } from 'react';
import './style.scss';
const ConfirmBox = ({ title = 'Confirm', message = null, placeholder, visible = false, onCancel, onConfirm, required = false }) => {
    const [comment, setComment] = useState('');
    const [msg, setMsg] = useState('');
    useEffect(() => {
        setMsg('');
    }, [])

    const handleConfirm = () => {
        if (required && (!comment || comment === '' || comment == null)) {
            setMsg(title + ' note is required.');
            return;
        }
        setComment('');
        onConfirm(comment);
        onCancel();
    };
    const handleCancel = () => {
        setComment('');
        onCancel();
    }

    return (<Dialog className='ess-dialog' header={<div className='ess-dialog-header'>
        <i className="pi pi-exclamation-triangle" style={{ marginRight: '8px' }}></i>
        {title}
    </div>} visible={visible} onHide={handleCancel} style={{ width: '400px' }}>
        <div className='ess-confirmbox-wrapper'>
            <p className='mb-0'>{message} {required && <span style={{ color: 'red' }}>*</span>}</p>
            <InputTextarea className='ess-confirm-input'
                value={comment} onChange={(e) => setComment(e.target.value)}
                placeholder={placeholder} rows="4" cols="50" resize="none"
            />
            {required && <div className='mb-3' style={{ color: 'red', marginTop: '-14px' }}>{msg}</div>}
            <div className="dialog-footer" style={{ textAlign: 'right' }}>
                <Button icon='pi pi-check' label="Confirm" onClick={handleConfirm} className='mr-2' />
                <Button icon='pi pi-times' label="Cancel" onClick={handleCancel} className='p-button-danger' />
            </div>
        </div>
    </Dialog>)
}

export default ConfirmBox;